/** @jsxImportSource @emotion/react */
import { css, CSSObject } from "@emotion/react";

import RectangleLoader from "../../shared/components/loaders/RectangleLoader";
import { useStyles } from "./styles";

interface IFilterSeparatorProps {
  isInitialLoading: boolean;
  width: number | string;
  height: number | string;
  light?: boolean;
  styles?: CSSObject;
}

const FilterSeparator = ({
  isInitialLoading,
  width,
  height,
  light,
  styles
}: IFilterSeparatorProps) => {
  const { filterSeparator } = useStyles({ width, light });

  return isInitialLoading ? (
    <RectangleLoader
      width={width}
      height={height}
      customStyle={{ margin: "0 16px" }}
    />
  ) : (
    <div css={css([filterSeparator, styles])} data-testid="filter-separator" />
  );
};

export default FilterSeparator;
